import theme from "@/theme";
import { FC, SVGProps } from "react";

interface PenSvgProps extends SVGProps<SVGSVGElement> {
  size?: string;
}

const PenSvg: FC<PenSvgProps> = ({ size = "medium", width, height, ...props }) => {
  if (size === "small") {
    return (
      <svg
        width={width}
        height={height}
        viewBox="0 0 36 36"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="1.5"
          y="1.5"
          width="33"
          height="33"
          rx="16.5"
          fill={theme.palette.custom.mainBlue}
        />
        <rect x="1.5" y="1.5" width="33" height="33" rx="16.5" stroke="white" stroke-width="3" />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M11.294 21.6185L21.62 11.2925C22.01 10.9025 22.643 10.9025 23.033 11.2925L24.709 12.9685C25.099 13.3585 25.099 13.9915 24.709 14.3815L14.382 24.7065C14.195 24.8945 13.941 24.9995 13.676 24.9995H11.001V22.3245C11.001 22.0595 11.106 21.8055 11.294 21.6185Z"
          stroke="white"
          stroke-width="2.25"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M19.749 13.1602L22.839 16.2502"
          stroke="white"
          stroke-width="2.25"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    );
  }

  // size === "medium"
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 36 36"
      width={width ?? 36}
      height={height ?? 36}
      {...props}
    >
      <path
        stroke={theme.palette.custom.mainBlue}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M27.52 7.312a3.361 3.361 0 0 1 0 4.752L11.701 27.883a3.167 3.167 0 0 1-1.472.833l-5.485 1.372 1.372-5.485a3.17 3.17 0 0 1 .833-1.472L22.77 7.311a3.36 3.36 0 0 1 4.75 0Z"
      />
      <path
        stroke={theme.palette.custom.mainBlue}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="m24.545 15.04-4.752-4.752M33.257 28.504l-1.733 1.733a4.9 4.9 0 0 1-6.93 0 4.91 4.91 0 0 0-6.932 0"
      />
    </svg>
  );
};

export default PenSvg;
